var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clone h-8 w-8 rounded-full bg-gray-300 flex items-center justify-center cursor-pointer",class:_vm.customClass,attrs:{"title":_vm.tooltip},on:{"click":function($event){return _vm.$emit('handleClone',_vm.row )}}},[_c('font-awesome-icon',{attrs:{"icon":"clone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }